"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var ArrayStrategy_1 = require("./Constants/ArrayStrategy");
var Messages = require("./Messages");
var Config = /** @class */ (function () {
    function Config() {
        this.deep = false;
        this.useReferenceIfTargetUnset = false;
        this.useReferenceIfArray = false;
        this.includeReadOnly = false;
        this.includeNonEmurable = false;
        this.arrayStrategy = ArrayStrategy_1.default.REPLACE;
        this.errorMessage = Messages.MERGE_ERROR;
        Object.seal(this);
    }
    return Config;
}());
exports.default = Config;
//# sourceMappingURL=Config.js.map